<template lang="pug">
    div(
        v-if="!hasSiteWideDefaultFullFitment"
        class="bg-gray-lighter p-3 lg:p-0"
    )
        div(class="lg:container")
            div(class="bg-white flex lg:px-5")
                div(class="flex-1 hidden md:block")
                    SameDayShippingItem(
                        class="hidden md:mr-3 xl:mr-5"
                        :class="fitmentSectionBorderColor"
                    )
                        template(#left)
                            FitmentIcon(class="w-20 h-auto mx-auto mb-1 fill-current xl:ml-0")
                            span(class="font-bold whitespace-nowrap leading-none") THE RIGHT FIT

                        template(#center)
                            p Hot deals on thousands of parts and accessories for your build

                        template(#button)
                            BaseButton(
                                @click.native="showFitmentModal"
                                size="SMALL"
                                :color="fitmentButtonColor"
                                :isDarkText="fitmentButtonIsDarkText"
                            ) Select Your Vehicle

                div(class="flex-1")
                    SameDayShippingItem(
                        @click.native="showFitmentModalSameDayShipping(false)"
                        class="md:ml-3 xl:ml-5"
                        :class="sameDayShippingBorderColor"
                    )
                        template(#left)
                            span(
                                class="text-white text-xs font-bold px-3 py-1"
                                :class="sameDayShippingBackgroundColor"
                            ) NEW
                            sameDayLogo(class="hidden w-32 h-auto md:block md:mt-3 md:mb-2 md:mx-auto xl:mb-0")

                        template(#center)
                            div(class="text-xs md:hidden")
                                sameDayLogo(class="w-32 h-auto")
                                | Fast shipping on select products
                            div(class="hidden md:block xl:text-sm") Enter your vehicle information to see products that ship the quickest

                        template(#button)
                            Arrow(
                                class="fill-current w-6 h-6 md:hidden"
                                :class="sameDayShippingTextColor"
                            )
                            div(class="hidden md:block")
                                BaseButton(
                                    @click.native.stop="showFitmentModalSameDayShipping(true)"
                                    size="SMALL"
                                    :color="sameDayShippingButtonColor"
                                )
                                    span(class="mr-2") Get Started
                                    Arrow(class="text-white fill-current w-5 h-5")

</template>

<script>
import SameDayLogo from '@/components/shipping/sameDayLogo'
import BaseButton from '@/components/baseButton'
import { sameDayShippingDisplayMixin } from '@/helpers/shipping'
import Arrow from '@/assets/arrow-right?inline'
import FitmentIcon from '@/components/fitmentIcon'
import SameDayShippingItem from './_components/sameDayShippingItem'

export default {
    name: 'SameDayShippingInline',
    components: {
        SameDayLogo,
        BaseButton,
        SameDayShippingItem,
        FitmentIcon,
        Arrow,
    },
    mixins: [sameDayShippingDisplayMixin],
    props: {
        fitmentButtonColor: {
            type: String,
            default: 'PRIMARY',
        },
        fitmentButtonIsDarkText: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasSiteWideDefaultFullFitment() {
            return this.$store.getters['fitment/hasSiteWideDefaultFullFitment']
        },
        sameDayShippingButtonColor() {
            if (this.$config.runtime.theme.sameDayShipping.mode === 'RAPIDSHIP') return 'SUCCESS'

            return 'INFO'
        },
        fitmentSectionBorderColor() {
            switch (this.fitmentButtonColor) {
                case 'PRIMARY_DARK':
                    return 'border-primary-dark'

                case 'SECONDARY':
                    return 'border-secondary'

                case 'PRIMARY':
                default:
                    return 'border-primary'
            }
        },
    },
    methods: {
        showFitmentModal() {
            this.$store.dispatch('fitment/showFitmentModal')
        },
        showFitmentModalSameDayShipping(forceClick = false) {
            if (this.$device.isMobile || forceClick)
                this.$store.dispatch('fitment/showFitmentModal', { isSameDayShippingMode: true })
        },
    },
}
</script>
